import { ChangeEventHandler, memo, PropsWithChildren } from 'react';
import { CheckIcon } from '../../icons/Check';
import { HTMLString } from '../../../types/HTMLString';
import classes from 'classnames';
import styles from './Checkbox.module.scss';
import Text from '../Typography/Text';

export type CheckboxProps = {
  touched?: boolean;
  dataTest?: string;
  disabled?: boolean;
  name?: string;
  className?: string;
  value: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  text?: HTMLString;
  highlight?: boolean;
  labelClassName?: string;
  errors?: boolean;
};

export default memo(function Checkbox({
  dataTest,
  name,
  className,
  disabled,
  value,
  onChange,
  text,
  highlight,
  labelClassName,
  errors,
}: PropsWithChildren<CheckboxProps>) {
  return (
    <div
      className={classes(
        styles.wrapper,
        value && styles.checked,
        disabled && styles.disabled,
        errors && styles.errors,
        className,
      )}
    >
      <div className={styles.checkmark}>
        <input
          type="checkbox"
          name={name}
          data-test={dataTest}
          disabled={disabled}
          checked={value}
          onChange={onChange}
          className={styles.checkbox}
        />
        <CheckIcon />
      </div>
      {text && (
        <Text
          level={2}
          className={classes(
            styles['checkbox-label'],
            highlight && styles.highlighted,
            labelClassName,
          )}
          dangerouslySetInnerHTML={{ __html: text }}
          kind="p"
        />
      )}
    </div>
  );
});
